import * as React from 'react'
import {Dialog, DialogDismiss, DialogHeading} from '@ariakit/react'
import * as dialogStyles from '@frontrow/console/src/components/dialog/dialog.module.scss'
import {Button} from '@frontrow/console/src/components/button'

// Models
import {type DetailedSchoolAdminT} from '@frontrow/console/src/models/school-admin'
// Components
import WarningMessage from '@frontrow/console/src/components/common/warning-message'
import * as style from './school-admins-verification-button-modal.module.scss'
import {useModalForm} from '@frontrow/console/src/hooks/use-modal-form'

type Props = {
  schoolAdmin: DetailedSchoolAdminT
}

function SchoolsAdminsVerificationButtonModal(props: Props): React.ReactElement {
  const {schoolAdmin} = props
  const {isOpen, open, close} = useModalForm()

  const {firstName, lastName, verificationUrl} = schoolAdmin

  const verificationLink =
    verificationUrl !== null && verificationUrl !== undefined
      ? verificationUrl
      : 'Error: No verification key'

  const warningMessage = `This verification link is enabled for a single use and should not be accessed by
      anyone besides the user it is intended for. Premature navigation to this link will
      disable it for our users.`

  return (
    <React.Fragment>
      <Button style="link" onClick={open}>
        <i className="fa fa-link fa-lg" />
      </Button>
      <Dialog
        open={isOpen}
        onClose={close}
        backdrop={<div className={dialogStyles.backdrop} />}
        className={dialogStyles.dialog}
        portal
        unmountOnHide
        hideOnEscape
        hideOnInteractOutside={false}
      >
        <div className={dialogStyles.header}>
          <DialogHeading className={dialogStyles.title}>
            Verification link for {`${firstName} ${lastName}`}
          </DialogHeading>
          <DialogDismiss className={dialogStyles.closeButton}>
            <span aria-hidden="true">&times;</span>
          </DialogDismiss>
        </div>
        <div className={dialogStyles.body}>
          <WarningMessage message={warningMessage} />

          <div className={style.verifictionLinkWrapper}>{verificationLink}</div>
        </div>
      </Dialog>
    </React.Fragment>
  )
}

export default SchoolsAdminsVerificationButtonModal
